import React from "react";
import { motion } from "framer-motion";
import { Icon } from "@iconify/react";
import { Button } from "@heroui/react";
import partnerLogo1 from "../assets/logos/ciayi-conf.png";
import partnerLogo3 from "../assets/logos/lebedeva.png";
import partnerLogo4 from "../assets/logos/l-club.png";
import partnerLogo5 from "../assets/logos/hakaton.png";
import partnerLogo6 from "../assets/logos/kaspian.png";
import partnerLogo7 from "../assets/logos/logo-shit.jpeg";

interface PartnersLogosProps {
  onViewMoreClick: () => void;
}

export const PartnersLogos: React.FC<PartnersLogosProps> = ({ onViewMoreClick }) => {
  // Partner logos - replacing icon sets with PNG image URLs
  const partnerLogos = [
    { name: "Конференция Сияй", imageUrl: partnerLogo1 },
    { name: "Нетворкинг клуб Елены Лебедевой", imageUrl: partnerLogo3 },
    { name: "Хакатон", imageUrl: partnerLogo5 },
  // L-Club has a mostly white logo on transparent background; use contrastBg
  { name: "L-Club", imageUrl: partnerLogo4 },
    { name: "Каспий", imageUrl: partnerLogo6 },
    { name: "губы", imageUrl: partnerLogo7 }
  ];

  return (
    <section className="py-24 bg-content2">
      <div className="container mx-auto px-6">
        <div className="text-center mb-16">
          <motion.div 
            className="relative"
            initial={{ opacity: 0, scale: 0.95 }}
            whileInView={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8, ease: [0.16, 1, 0.3, 1] }}
            viewport={{ once: true, margin: "-100px" }}
          >
            <h2 className="text-3xl md:text-4xl font-light mb-4">Наши <span className="font-medium">партнёры</span></h2>
            <p className="text-foreground/70 max-w-2xl mx-auto">
              Бренды, которые уже выбрали нашу продукцию для своего бизнеса
            </p>
          </motion.div>
        </div>

        <div className="max-w-6xl mx-auto">
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-4 lg:grid-cols-4 gap-6 md:gap-8">
            {partnerLogos.map((logo: any, index) => (
              <div 
                key={index} 
                className="flex justify-center"
              >
                {/*
                  Use `group` on the container and Tailwind `filter grayscale` to show
                  logos in black-and-white by default. On hover (`group-hover:grayscale-0`)
                  they smoothly transition to color. If a logo needs inversion (dark bg),
                  apply `invert` class so it remains visually correct while still following
                  the grayscale -> color transition.
                */}
                <div className={`w-72 h-62 flex items-center justify-center rounded-md border p-4 group ${logo.contrastBg ? 'bg-slate-800 border-slate-700' : 'bg-slate-100 border-divider'}`}>
                  <img 
                    src={logo.imageUrl} 
                    alt={logo.name}
                    className={`max-w-full max-h-full object-contain transition-all duration-300 ease-in-out ${logo.noGrayscale ? '' : 'filter grayscale group-hover:grayscale-0'} ${logo.invert ? 'invert' : ''}`}
                    style={logo.contrastBg ? { filter: `${logo.invert ? 'invert(1) ' : ''}drop-shadow(0 2px 6px rgba(0,0,0,0.6))` } : undefined}
                  />
                </div>
              </div>
            ))}
          </div>
        </div>

        {/* Keep the CTA button */}
        <div className="text-center mt-12">
          <Button 
            color="primary" 
            variant="flat" 
            endContent={<Icon icon="lucide:arrow-right" width={16} />}
            onPress={onViewMoreClick}
          >
            Стать нашим партнером
          </Button>
        </div>
      </div>
    </section>
  );
};